import { useGet } from '../../../sharedModules/hooks/useQuery';
import { CollectionClientNote } from '../model';

export function useCollectionClientNotes(clientId: number | null, enabled = true) {
  return useGet<CollectionClientNote[]>({
    url: clientId ? `/collections/clients/${clientId}/notes` : '',
    enabled: !!clientId && enabled,
  });
}
